<template>
  <PaymentForm />
</template>
<script setup>
import { useTitle } from "@vueuse/core";
import PaymentForm from "@/components/forms/PaymentForm.vue";

useTitle("Banxa - Choose a payment method");
</script>
